import { WorkingStepType } from '../services/APIs/InternalAPI/internal-api.contracts'

export const WorkingStepTypeLabel = new Map<WorkingStepType, string>([
  [WorkingStepType.NotInitialized, 'undefined'],
  [WorkingStepType.SheetCutting, 'sheet cutting'],
  [WorkingStepType.Sawing, 'sawing'],
  [WorkingStepType.SheetBending, 'bending'],
  [WorkingStepType.CounterSinking, 'counter sinking'],
  [WorkingStepType.Milling, 'milling'],
  [WorkingStepType.TubeOrProfileCutting, 'tube or profile cutting'],
  [WorkingStepType.Turning, 'turning'],
  [WorkingStepType.Purchasing, 'purchasing'],
  [WorkingStepType.Engraving, 'engraving'],
  [WorkingStepType.ThreadTapping, 'thread tapping'],
  [WorkingStepType.Anodising, 'anodising'],
  [WorkingStepType.Assembling, 'assembling'],
  [WorkingStepType.BoltPressing, 'bolt pressing'],
  [WorkingStepType.Deburring, 'deburring'],
  [WorkingStepType.Drilling, 'drilling'],
  [WorkingStepType.EdgeMilling, 'edge milling'],
  [WorkingStepType.EdgeTrimming, 'edge trimming'],
  [WorkingStepType.LevelTensioning, 'level tensioning'],
  [WorkingStepType.NutPressing, 'nut pressing'],
  [WorkingStepType.PicklingPassivating, 'pickling passivating'],
  [WorkingStepType.Polishing, 'polishing'],
  [WorkingStepType.ElectrolyticPolishing, 'electrolytic polishing'],
  [WorkingStepType.PowderCoating, 'powder coating'],
  [WorkingStepType.Punching, 'punching'],
  [WorkingStepType.Rolling, 'rolling'],
  [WorkingStepType.StudWelding, 'stud welding'],
  [WorkingStepType.TubeProfileOrBarBending, 'tube profile or bar bending'],
  [WorkingStepType.Welding, 'welding'],
  [WorkingStepType.ZincPlating, 'zinc plating'],
  [WorkingStepType.Designing, 'designing'],
  [WorkingStepType.Loading, 'loading'],
  [WorkingStepType.Unloading, 'unloading'],
  [WorkingStepType.SheetShearing, 'sheet shearing'],
  [WorkingStepType.Setup, 'setup'],
  [WorkingStepType.Certifying, 'certifying'],
  [WorkingStepType.Shipping, 'shipping'],
  [WorkingStepType.DieSinking, 'die sinking'],
  [WorkingStepType.Nitriding, 'nitriding'],
  [WorkingStepType.RobotStudWelding, 'robot stud welding'],
  [WorkingStepType.RobotWelding, 'robot welding'],
  [WorkingStepType.WireErosion, 'wire erosion'],
  [WorkingStepType.Hemming, 'hemming'],
  [WorkingStepType.Cleaning, 'cleaning'],
  [WorkingStepType.CathodicDipCoating, 'cathodic dip coating'],
  [WorkingStepType.ElectrophoreticDipCoating, 'electrophoretic dip coating'],
  [WorkingStepType.FlowDrilling, 'flow drilling'],
  [WorkingStepType.Foiling, 'foiling'],
  [WorkingStepType.HoleProtectioning, 'hole protectioning'],
  [WorkingStepType.Operating, 'operating'],
  [WorkingStepType.QualityControlling, 'quality controlling'],
  [WorkingStepType.Researching, 'researching'],
  [WorkingStepType.VibratoryDeburring, 'vibratory deburring'],
])
